import { Component, Output, EventEmitter, OnInit, Input, DestroyRef, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { Service } from './ctl-teb-kurum-sinif-arama.service';
import { DxButtonModule } from 'devextreme-angular';
import { ColumnModel } from '../../../../models/dx-data-table.model';
import { DkDxDataCtlTableComponent } from '../../../dk-dx-data-ctl-table/dk-dx-data-ctl-tablecomponent';
import { Observable } from 'rxjs';
import { TebKurumSinifService } from '../ctl-teb-kurum-sinif.service';
import { OrtakService } from '../../../../services/ortak.service';
import { CommonModule } from '@angular/common';
import {DlistDto} from "@dabnet-kamu/libs/ui";
@Component({
  selector: 'dk-ctl-teb-kurum-sinif-arama',
  templateUrl: './ctl-teb-kurum-sinif-arama.component.html',
  styleUrls: ['./ctl-teb-kurum-sinif-arama.component.scss'],
  standalone: true,
  imports: [DkDxDataCtlTableComponent, DxButtonModule,CommonModule],
  providers: [Service],
})
export class CtlTebKurumSinifAramaComponent implements OnInit   {
  private destroyRef = inject(DestroyRef);
  @Input() filterColumn = "";
  @Input() filterColumnValue: any;
  public data: any;
  public columns: ColumnModel[];
  public selectedData: any = null;
  gridControlsList$: Observable<DlistDto>;
  @Input() control: any;
  @Input() modul: string;
  @Output() private closePopup = new EventEmitter<string>();
  public filterValue:any
  constructor(
    private service: Service,
    private tebKurumSinifService:TebKurumSinifService,
    public ortakService:OrtakService
  ) {

  }

  ngOnInit(): void {
    if(this.filterColumnValue){
      this.filterValue = [this.filterColumn, 'startswith', this.filterColumnValue]
    }

    this.data = this.service.getData(this.control, this.modul);
    this.gridControlsList$ = this.tebKurumSinifService.gridControlsList$;
    this.tebKurumSinifService.gridControlsList$.pipe(takeUntilDestroyed(this.destroyRef)).subscribe(x=>{
      this.columns = this.ortakService.setRecursiveFieldData([x],false);
      })

  }

  focusChanged(e: any) {
    this.selectedData = e.row;
  }


  onKeyDown(e: any) {
  if (e.event?.key === 'Enter') {
      this.filterColumnValue = undefined;
      this.closePopup.emit(this.selectedData);
    }
  }

  dblClickRow(e:any){
    this.filterColumnValue = undefined;
    this.closePopup.emit(e);
  }
  chooseBtnClick() {
    this.filterColumnValue = undefined;
    this.closePopup.emit(this.selectedData);
  }

  cancelBtnClick() {
    this.filterColumnValue = undefined;
    this.closePopup.emit(null);
  }
}
